import { cva, VariantProps } from 'class-variance-authority';
import { ComponentPropsWithRef } from 'react';
import { Icon } from '@/shared/ui/icon';
import './tabs.scss';

const scrollIndicatorVariants = cva('tabs__scroll-indicator', {
    variants: {
        side: {
            left: 'tabs__scroll-indicator--left',
            right: 'tabs__scroll-indicator--right',
        },
    },
    defaultVariants: {
        side: 'left',
    },
});

type Props = ComponentPropsWithRef<'button'> & VariantProps<typeof scrollIndicatorVariants>;
export const TabsScrollIndicator = ({ side, ...props }: Props) => {
    return (
        <button
            type="button"
            className={scrollIndicatorVariants({ side })}
            data-testid="tabs-scroll-indicator-button"
            data-side={side}
            aria-label={side === 'right' ? 'Scroll tabs right' : 'Scroll tabs left'}
            {...props}
        >
            <Icon name="chevron-right" />
        </button>
    );
};
